module.exports = "/images/eg.svg?af897b602e090441a6637de118a21f4f";